import React from 'react';
import PropTypes from 'prop-types';

import { __t } from '@mssgme/shared';
import { ua } from '@mssgme/helpers';
import { Modal } from '../Modal';
import styles from './styles.scss';

export class OpenMessengerModal extends React.Component {
    static propTypes = {
        message: PropTypes.any.isRequired,
        url: PropTypes.string.isRequired,
        platform: PropTypes.string,
    };

    static defaultProps = {
        visible: false,
    };

    constructor(props) {
        super(props);

        this.templateRef = React.createRef();
    }

    handleClick = (e) => {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.templateRef.current);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');

        if (ua.Android) {
            e.preventDefault();

            const href = e.target.href;

            window.open(href);
        }
    };

    render() {
        const { message, url, platform, ...rest } = this.props;

        return (
            <Modal title={__t('product_copy_heading')} {...rest}>
                <div className={styles.copy} ref={this.templateRef}>
                    {message}
                </div>
                <a href={url} className={styles.button} onClick={this.handleClick} data-product-messenger={platform}>
                    {__t('products_copy_open')} <span>{platform}</span>
                </a>
            </Modal>
        );
    }
}
